import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-volumn',
  templateUrl: './icon-volumn.component.html',
  styleUrls: ['./icon-volumn.component.scss']
})
export class IconVolumnComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
